// react-bootstrap imports
import { useLocation } from "react-router-dom"
import { useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner'
import { useNavigate } from "react-router-dom"

// components imports
import { FiltrosTabelaProcessos } from "components/Filtros"
import { ButtonVer, TabelaBanco } from "components/Tabela"

import { userLogado, userData} from "services/LoginFunctions"

// custom hook imports
import { useProcessos } from 'hooks/useProcessos';

// constant imports
import * as Links from "constants/links"


const ButtonVerProcesso = ({ procData, filtersApplied, currentPaginationInfo }) =>
{
    const state = {
        statePrevPage: {
            "filtersApplied": filtersApplied,
            "currentPaginationInfo": currentPaginationInfo
        },
        linkPrevPage: Links.MEUS_PROCESSOS,
        procData: procData
    }
    return(
        <ButtonVer url={Links.VER_PROCESSO} state={state} text={"Ver Processo"} altText={"Botão para visualizar o processo"} />
    )
}

export function TabelaDeProcessos()
{
    const location = useLocation()
    const state = location.state
    const initialFilterVals = state? 
        state.filtersApplied : 
        {
            particip: userData()['matricula'],
            numProc: "",
            nomeAnalista: "",
            tipoDocumento: "",
            nomeProprietario: "",
            inscCadastral: "",
            dataCriacao: "",
            currentPage: 1,
            itemsPerPage: 10,
            sortBy: "createdAt",
            sortDesc: true
        }
    const initialPagination = state? 
        state.pagination : 
        {
            currentPage: 1,
            numPages: 1,
            itemsPerPage: 10,
            totalItems: 0
        }

    const 
    {
        loading,
        allProcs,
        pagination,
        inputFilters, 
        filterVals,
        handleInputChange,
        handleSortChange,
        handlePageChange,
        handleFiltrarClick,
        handleSwitchParticip,
        fetchData
    } = useProcessos(initialFilterVals, initialPagination)

    useEffect(() =>
    {
        if(loading)
        {
            fetchData()
        }
    }, [fetchData, loading])
    
    const title = "Tabela de processos" 
    const headers = [
        { varName: "numProc", name: "Nº Processo", sortable: true },
        { varName: "anoProc", name: "Ano Processo", sortable: true },
        { varName: "createdAt", name: "Data de criação", sortable: true },
        { varName: "numDocs", name: "Quantidade de documentos", sortable: false },
        { varName: "actions", name: "Ações", sortable: false }
    ]

    const elementsWithAction = allProcs?.map(
        element => ({...element, actions: <ButtonVerProcesso procData={element} filtersApplied={filterVals} currentPaginationInfo={pagination} /> })
    ) ?? []

    const FiltrosTabela = (handleFilterChange, handleFiltrarClick, handleSwitchParticip) => (
        <FiltrosTabelaProcessos handleFilterChange={handleFilterChange} 
                                handleFiltrarClick={handleFiltrarClick} 
                                handleSwitchParticip={handleSwitchParticip} 
                                filterVals={inputFilters} />
    )

    return(
        <>
            {loading?
            <div className = "d-flex flex-column align-items-center my-5">
                <Spinner animation="border" variant="primary" />
            </div>
            :
            <TabelaBanco title={title}
                    headers={headers} elements={elementsWithAction} 
                    msgNenhumEncontrado={"Nenhum processo encontrado"} 
                    FiltrosTabela={FiltrosTabela(handleInputChange, handleFiltrarClick, handleSwitchParticip)}
                    sortBy={handleSortChange}
                    pagination={pagination} setPage={handlePageChange} />
            }
        </>
    )
}

export const MeusProcessosScreen = () =>
{
    const navigate = useNavigate()
    if (!userLogado) { navigate(Links.SEM_PERMISSAO) }

    return (
        <div className="container align-items-center bg-white border border-dark rounded-5 mb-3 shadow">
            <TabelaDeProcessos />
        </div>
    )
}